import { TextField, InputAdornment, debounce } from "@mui/material";
import { useFormikContext } from "formik";
import { checkFieldError } from "../../../helpers";
import PropTypes from "prop-types";
import useUserEvent from "../../../hooks/useUserEvent";
import useStepper from "../../../hooks/useStepper";
import { useEffect, useState } from "react";

const IconInputField = ({
  id,
  name,
  label,
  value,
  styleClass,
  customError,
  trackingDetails,
  handleChangeValue,
  handleBlurValue,
  disabled = false,
  isValidValue = () => true,
  icon,
}) => {
  const { touched, errors, values } = useFormikContext();

  const { userTrackingMutation } = useUserEvent();
  const { trackingCode } = useStepper();
  const [fieldValue, setFieldValue] = useState(values[name] || value);

  const handleUserEvent = (element) => {
    if (element?.target?.value) {
      userTrackingMutation({
        variables: {
          ...trackingDetails,
          field_name: element?.target?.name || name || "",
          field_value: element?.target?.value?.toString() || "",
          avc_track_code: trackingCode,
        },
      });
    }
  };

  useEffect(() => {
    setFieldValue(values[name] || value);
  }, [values[name], value]);

  const debouncedHandleChange = debounce((e) => {
    handleChangeValue && handleChangeValue(e, isValidValue(e));
  }, 500);

  return (
    <>
      <TextField
        id={id}
        name={name}
        label={label}
        value={fieldValue}
        variant="outlined"
        className={`${styleClass} mt-18`}
        color="mmm"
        fullWidth
        disabled={disabled}
        onChange={(e) => {
          debouncedHandleChange(e);
          isValidValue(e) ? setFieldValue(e?.target?.value) : setFieldValue("");
        }}
        onFocus={(e) => {
          handleUserEvent(e);
        }}
        onBlur={(e) => {
          handleUserEvent(e);
          handleBlurValue && handleBlurValue(e);
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">{icon}</InputAdornment>
          ),
        }}
        error={
          customError && customError[name]
            ? customError[name]
            : checkFieldError(touched, errors, name)
        }
        helperText={
          customError && customError[name]
            ? customError[name]
            : checkFieldError(touched, errors, name)
        }
      />
    </>
  );
};

IconInputField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  styleClass: PropTypes.string,
  handleChangeValue: PropTypes.func,
  handleBlurValue: PropTypes.func,
  isValidValue: PropTypes.func,
  trackingDetails: PropTypes.object,
  icon: PropTypes.any,
  disabled: PropTypes.bool,
  customError: PropTypes.object,
};

export default IconInputField;
